import { checkHttpStatus, parseJSON, objectToQueryString, expiredToken } from '../../utils/response';
import { Token, UserCode, Company, EmployeeId, EmployeeCode, Worksite } from '../../utils/users';
import { GetLanguage } from '../../utils/language';
import { errorResponse } from '../../utils/response';

export function getBank() {
    const param = objectToQueryString({ userCode: UserCode(), employeeId: EmployeeId(), employeeCode: EmployeeCode(), company: Company(), token: Token(), language: GetLanguage() });

    let url = 'bankbalance/getBank?' + param;

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getBankVacation() {
    const param = objectToQueryString({ userCode: UserCode(), employeeCode: EmployeeCode(), company: Company(), token: Token() });

    let url = 'bankbalance/getBankVacation?' + param;

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getCurrentBanks() {
    const param = objectToQueryString({ userCode: UserCode(), employeeCode: EmployeeCode(), company: Company(), token: Token(), language: GetLanguage() });

    let url = 'bankbalance/getCurrentBanks?' + param;

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}

export function getCurrentBankVacation() {
    const param = objectToQueryString({ userCode: UserCode(), employeeCode: EmployeeCode(), company: Company(), token: Token() });

    let url = 'bankbalance/getCurrentBankVacation?' + param;

    return fetch(url, {
        method: 'get',
        credentials: 'include',
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
        }
    })
        .then(checkHttpStatus)
        .then(expiredToken)
        .then(parseJSON)
        .then(response => {
            try {
                return response;
            } catch (e) {
                errorResponse(response);
            }
        })
        .catch(error => {
            errorResponse(error);
        })
}